
/**
 * JavaScript React Framework
 */
import React from 'react';
// import ReactDom from 'react-dom';

/**
 * React-Bootstrap
 */ 
import { Jumbotron, Panel, Thumbnail, PageHeader, Button, Grid, Row, Col } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import MarketingBlock from '../../common/content/MarketingBlock.js';

import imgHeader_01 from '../../../assets/img/lms/Space_01.jpg';
import imgHeader_02 from '../../../assets/img/lms/Space_02.jpg';
import imgHeader_03 from '../../../assets/img/lms/PreProcessor.jpg';
import imgHeader_04 from '../../../assets/img/lms/MemoryBoundaries.jpg';

import zip_01 from '../../../assets/zip/lms/TracyStevenBrown_LMS_Webserver.zip';

let fontSize = {fontSize: '1.10em'};

/**
 * Note: Your components tell React what you want to render
 */
class LMS extends React.Component {
	render() {
		return (
			<div id="ITBuildOut">
				<Jumbotron>
	          <div>
	          	<Grid>
				    		<Row>
				    			<Col xs={12} md={12}>
				    				<center>
					    				<Panel>
					    					<span><center><PageHeader>Software Engineering<br/><small>Learning Management System &amp; Web-Server</small></PageHeader></center></span>

					    					<p className="lead text-justify">With permission from Performance Associates International (<a href="http://www.perfnet.com">PAI</a>), I've posted an example of my C software engineering work showcasing the effective use of <a href="https://en.wikipedia.org/wiki/C_preprocessor">pre-processing</a> statements (stack tracing), Solaris task queue integration, kernel threads, as well as <a href="https://en.wikipedia.org/wiki/XML">XML</a>/<a href="https://en.wikipedia.org/wiki/JSON">JSON</a> parsing, link checking, etc. Of particular note are the <a href="https://en.wikipedia.org/wiki/Design_pattern">design patterns</a> of my own creation: chains, tables, lattice as well as an in-memory database inspired from the <a href="https://en.wikipedia.org/wiki/Flyweight_pattern">flyweight</a> pattern, all implemented in <a href="https://en.wikipedia.org/wiki/C_(programming_language)">C</a>. The code illustrates spawning <a href="https://en.wikipedia.org/wiki/Daemon_(computing)">daemons</a>, opening and managing <a href="https://en.wikipedia.org/wiki/Internet_protocol_suite">TCP/IP</a> sockets, <a href="https://en.wikipedia.org/wiki/Hypertext_Transfer_Protocol">HTTP</a> authentication, and talking to the administrator via <a href="https://en.wikipedia.org/wiki/Named_pipe">named-pipes</a>. If you choose to use some of my code, make a note in your code and buy me a cup of coffee sometime.</p>
					    				</Panel>
				    				</center>
				    			</Col>
				    		</Row>

				    		<Row>
				    			<Col xs={12} md={6}>
				    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_01}>
				    				<h3>Chief Engineer</h3>
						         <p className="text-justify" style={fontSize}>This project spanned systems engineering with a custom high performance web-server embedded into the application alongside an embedded MySQL database. In-between the database and webserver was a custom in-memory caching database of my own creation based on a self-leveling binary tree inspired from the flyweight design pattern. Most of the algorithmic work was based on <a href="https://en.wikipedia.org/wiki/C%2B%2B">C++</a> design patterns where possible; however, the underlying source code was written in <a href="https://en.wikipedia.org/wiki/C_(programming_language)">C</a>.</p>
				    				</Thumbnail>
				    			</Col>

				    			<Col xs={12} md={6}>
				    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_02}>
				    				<h3>Task Queues</h3>
						         <p className="text-justify" style={fontSize}>The web-server was very responsive and based on <a href="https://en.wikipedia.org/wiki/Solaris_(operating_system)">Solaris</a> Kernel <a href="https://docs.oracle.com/cd/E18752_01/html/816-4854/task_queues.html">Task-Queues</a>. Task-Queues are used in device-driver development and provide a mechanism to introduce user-level code into the kernel via kernel execution threads. The purpose of the web-server was to build a competitive performance-oriented web application server that was clean and capable of out-performing the popular <a href="https://en.wikipedia.org/wiki/Apache_HTTP_Server">Apache</a> web-server. During development, both <a href="https://docs.oracle.com/cd/E19683-01/817-3801/whatsnew-s9fcs-101/index.html">DISM</a> and ISM memory mappings were investigated.</p>
				    				</Thumbnail>
				    			</Col>
				    		</Row>
				    	</Grid>
	          </div>

	          <center>
	          	<Button href={zip_01}>Project Source</Button>
	          </center>
				</Jumbotron>

				<Grid className="blockpadding">
	    		<div className="well">
		    		<Row>
		    			<Col xs={12} md={6}>
		    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_03}>
			    				<h3>Preprocessor Statements</h3>
					        <p className="text-justify" style={fontSize}>The <a href="https://en.wikipedia.org/wiki/C_preprocessor">preprocessor</a> statements are advanced and help to keep the code very clean in terms of error checking. I make heavy use of the preprocessor to build error checking routines, function headers and footers, and to build a stack trace. The code is very robust. One of the defining aspects of my C programming style is casting to void when no return code is expected or if I choose to ignore a return code. It lets me know that I did this on purpose.</p>
			    			</Thumbnail>
		    			</Col>

		    			<Col xs={12} md={6}>
		    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_04}>
			    				<h3>Kernel Threads &amp; User Memory</h3>
					        <p className="text-justify" style={fontSize}>The webserver aspect was designed for performance - I wrote this to a specific architecture on a specific platform to compete with <a href="https://en.wikipedia.org/wiki/Apache_HTTP_Server">Apache</a> as a performance web server. Kernel task queues were used to manage inbound <a href="https://en.wikipedia.org/wiki/Internet_protocol_suite">TCP/IP</a> connections for handling <a href="https://en.wikipedia.org/wiki/Hypertext_Transfer_Protocol">HTTP</a> requests. HTTP requests were then handled with user space memory via a custom development memory management system and the careful carving of memory boundaries within my structures.</p>
			    			</Thumbnail>
		    			</Col>
		    		</Row>

						<Row>
							<Col xs={12} md={6}>
		    				<MarketingBlock header="HTML Link Checking">
		    					As a <a href="https://en.wikipedia.org/wiki/Sharable_Content_Object_Reference_Model">SCORM</a> complaint learning management system, this code required content designers to upload <a href="https://en.wikipedia.org/wiki/XHTML">XHTML</a> <a href="https://en.wikipedia.org/wiki/Learning_object">SCO</a> packages. The learning management system unpacks these <a href="https://en.wikipedia.org/wiki/Learning_object">SCOs</a>, opens each <a href="https://en.wikipedia.org/wiki/XHTML">XHTML</a> file, and verifies that all links are correct and the formatting conforms to the <a href="https://en.wikipedia.org/wiki/XHTML">XHTML</a> standard. A user interface dialog displays each error with the exact location within the source file.
		    				</MarketingBlock>
		    			</Col>

		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="Front-End Flex">
		    					The front-end of the <a href="https://en.wikipedia.org/wiki/Learning_management_system">LMS</a> is developed in <a href="https://en.wikipedia.org/wiki/XHTML">XHTML</a> and <a href="https://en.wikipedia.org/wiki/Adobe_Flash">Flash</a>/<a href="http://www.adobe.com/products/flex.html">Flex</a> - note that the front-end is not available in the above download. Communication between the front-end website and the backend webserver/<a href="https://en.wikipedia.org/wiki/Learning_management_system">LMS</a> was done via both <a href="https://en.wikipedia.org/wiki/JSON">JSON</a> and <a href="https://en.wikipedia.org/wiki/XML">XML</a>. Parsing was handled on both sides using a common format for communication.
		    				</MarketingBlock>
		    			</Col>
		    		</Row>

		    		<Row>
		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="UNIX Daemons">
		    					The code shows a clean example of spawning and managing child processes in a <a href="https://en.wikipedia.org/wiki/Unix">UNIX</a> environment as well as conveying system errors and information via syslog. Note that the entire codebase is wrapped in pre-processor statements managing return codes and tracing the stack.
		    				</MarketingBlock>
		    			</Col>

		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="Design Patterns">
		    					While <a href="https://en.wikipedia.org/wiki/Design_pattern">design patterns</a> are typically applied in C++ and other object-oriented languages, my code, written in C on <a href="https://en.wikipedia.org/wiki/Solaris_(operating_system)">Solaris</a> UNIX, illustrates the use of several C-style design patterns inspired from the works of Kernighan, Ritchie, and Rochkind. Patterns were applied where possible.
		    				</MarketingBlock>
		    			</Col>
		    			
		    		</Row>

	    		</div>
	    	</Grid>

    	</div>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default LMS;



// WEBPACK FOOTER //
// ./src/cba/appspec/body/LMS.js